module["exports"] = [
  "SPA",
  "e figli",
  "Group",
  "s.r.l."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/company/suffix.js
 ** module id = 685
 ** module chunks = 0
 **/